<mat-card appearance="outlined" class="tw-basis-full">
  <mat-card-title class="tw-flex tw-justify-center tw-items-center">
    <h1 class="title">{{ 'administration.mapsPluginDialog.title' | translate }}</h1>
  </mat-card-title>
  <mat-card-content class="tw-flex">
    <div class="tw-basis-full">
      <p>{{ 'administration.mapsPluginDialog.intro' | translate }}</p>
      <p>{{ 'administration.mapsPluginDialog.whatThisMeans' | translate }}</p>
      <ul>
        <li>{{ 'administration.mapsPluginDialog.bulletPoints.mapsLoadedFromGoogle' | translate }}</li>
        <li>{{ 'administration.mapsPluginDialog.bulletPoints.usageDataShared' | translate }}</li>
        <li>{{ 'administration.mapsPluginDialog.bulletPoints.privacyPolicyApplies' | translate }}</li>
      </ul>
      <p>{{ 'administration.mapsPluginDialog.optionalNote' | translate }}</p>
      <p>{{ 'administration.mapsPluginDialog.question' | translate }}</p>
      <div class="tw-flex tw-justify-end tw-gap-x-4">
        <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="dismiss()"></ui-action-button>
        <ui-action-button [action]="buttonAction.Accept" (buttonClick)="enable()"></ui-action-button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
